import React from 'react';
import '../styles/TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Use</h1>
      <p>
        By accessing or using the DOKO Battlefield website and services, you agree to the following terms:
      </p>

      <h3>1. Acceptance of Terms</h3>
      <p>
        Use of this site and participation in any DOKO Battlefield experience implies acceptance of these terms. If you disagree, please do not use the site.
      </p>

      <h3>2. Intellectual Property</h3>
      <p>
        All content on this site, including graphics, logos, videos, and trademarks, are property of DOKO Battlefield and may not be used without permission.
      </p>

      <h3>3. Conduct</h3>
      <p>
        Users must not submit inappropriate content or attempt to access restricted features without authorization. Violations may result in account suspension or legal action.
      </p>

      <h3>4. Limitation of Liability</h3>
      <p>
        DOKO Battlefield is not liable for damages arising from the use of this website or participation in events, beyond the extent allowed by law.
      </p>

      <h3>5. Modifications</h3>
      <p>
        We may revise these terms at any time. Continued use of the site after updates constitutes acceptance of the new terms.
      </p>
    </div>
  );
};

export default TermsOfUse;

